<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      d="M8.8 12.112V4H7.2V12.112C5.824 12.472 4.8 13.712 4.8 15.2S5.824 17.928 7.2 18.288V20H8.8V18.288C10.176 17.928 11.2 16.688 11.2 15.2S10.176 12.472 8.8 12.112M8 13.6C8.88 13.6 9.6 14.32 9.6 15.2S8.88 16.8 8 16.8C7.12 16.8 6.4 16.08 6.4 15.2S7.12 13.6 8 13.6M16.8 4H15.2V5.712C13.824 6.072 12.8 7.312 12.8 8.8S13.824 11.528 15.2 11.888V20H16.8V11.888C18.176 11.528 19.2 10.288 19.2 8.8S18.176 6.072 16.8 5.712V4M16 7.2C16.88 7.2 17.6 7.92 17.6 8.8S16.88 10.4 16 10.4C15.12 10.4 14.4 9.68 14.4 8.8S15.12 7.2 16 7.2Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconController',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>